import type { SpareCategory } from './useData';

export const moduleConfig = {
  module: {
    title: 'Spare categories',
    permissionModuleKey: 'spare_categories',
    route: {
      list: '/spares/spare-items',
      new: '/spares/spare-items',
      detail: (_id: number) => '/spares/spare-items',
      edit: (_id: number) => '/spares/spare-items',
    },
    api: {
      list: '/spare-categories',
      detail: (id: number) => `/spare-categories/${id}`,
      tree: (libraryId: number) => `/spare-categories/tree/${libraryId}`,
    },
  },
  form: {
    new: { title: 'New spare category', submitText: 'Create' },
    edit: { title: 'Edit spare category', submitText: 'Save' },
    cancelText: 'Cancel',
    loadingText: 'Loading...',
    errorMessage: 'Save failed.',
    create: async (data: Partial<SpareCategory>) => {
      const { createSpareCategory } = await import('../../../services/mutations');
      return createSpareCategory(data as Record<string, unknown>);
    },
    update: async (id: number, data: Partial<SpareCategory>) => {
      const { updateSpareCategory } = await import('../../../services/mutations');
      return updateSpareCategory(id, data as Record<string, unknown>);
    },
  },
  delete: {
    title: 'Delete spare category',
    message: 'Delete this category?',
    confirmText: 'Delete',
    cancelText: 'Cancel',
    errorMessage: 'Could not delete category.',
    handler: async (id: number) => {
      const { deleteSpareCategory } = await import('../../../services/mutations');
      await deleteSpareCategory(id);
    },
  },
};


export type ModuleConfig = typeof moduleConfig;

export const getInitialFormData = (): Partial<SpareCategory> => ({
  libraryId: undefined,
  pid: null,
  name: '',
  abrv: '',
  sortOrder: 0,
  isActive: true,
});

export const mapItemToFormData = (item: SpareCategory): Partial<SpareCategory> => ({
  libraryId: item.libraryId,
  pid: item.pid ?? null,
  name: item.name,
  abrv: item.abrv ?? '',
  sortOrder: item.sortOrder ?? 0,
  isActive: item.isActive ?? true,
});
